import { render, staticRenderFns } from "./ExchangeRewardPage.vue?vue&type=template&id=de195d9a"
import script from "./ExchangeRewardPage.vue?vue&type=script&lang=js"
export * from "./ExchangeRewardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsSkeletonLoader: require('/app/components/Commons/SkeletonLoader.vue').default,Theme2MissionExchangeRewardTypeToggle: require('/app/components/Theme2/Mission/ExchangeReward/TypeToggle.vue').default,Theme2MissionDesktopCreditExchangeRewardTab: require('/app/components/Theme2/Mission/Desktop/CreditExchangeRewardTab.vue').default,Theme2MissionDesktopItemExchangeRewardTab: require('/app/components/Theme2/Mission/Desktop/ItemExchangeRewardTab.vue').default,Theme2MissionTermAndConditionDialog: require('/app/components/Theme2/Mission/TermAndConditionDialog.vue').default})
